import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useContent } from "../content/ContentContext";
import { EASE_OUT } from "./Reveal";

export const Quotes = () => {
  const [index, setIndex] = useState(0);
  const { QUOTES } = useContent();

  useEffect(() => {
    const t = setInterval(() => setIndex((i) => (i + 1) % QUOTES.length), 5600);
    return () => clearInterval(t);
  }, [QUOTES.length]);

  return (
    <section className="relative py-32 md:py-44 overflow-hidden" data-testid="quotes-section">
      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[560px] h-[560px] rounded-full bg-gold/[0.05] blur-[160px] pointer-events-none" />
      <div className="relative max-w-5xl mx-auto px-6 lg:px-10 text-center">
        <span className="font-display text-7xl md:text-8xl text-gold/25 leading-none select-none" aria-hidden="true">
          "
        </span>
        <div className="min-h-[9rem] md:min-h-[11rem] flex items-center justify-center -mt-6 md:-mt-10">
          <AnimatePresence mode="wait">
            <motion.blockquote
              key={index}
              initial={{ opacity: 0, y: 14 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -14 }}
              transition={{ duration: 1.1, ease: EASE_OUT }}
              className="font-quote italic text-3xl md:text-5xl leading-snug text-ivory/95"
              data-testid="rotating-quote"
            >
              {QUOTES[index]}
            </motion.blockquote>
          </AnimatePresence>
        </div>
        <div className="flex justify-center gap-2.5 mt-10">
          {QUOTES.map((_, i) => (
            <button
              key={i}
              onClick={() => setIndex(i)}
              aria-label={`Quote ${i + 1}`}
              className={`h-[3px] rounded-full transition-[width,background-color] duration-500 ${
                i === index ? "w-8 bg-gold" : "w-3 bg-white/20 hover:bg-white/40"
              }`}
              data-testid={`quote-dot-${i}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};
